<template>
  <el-container>
    <el-aside width="200px">
      <el-menu
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <div class="menu-logo">Jarvis</div>
        <el-menu-item index="index" @click="goto('index')">
          <i class="el-icon-orange"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="androids" @click="goto('androids')">
          <i class="el-icon-mobile-phone"></i>
          <span slot="title">安卓</span>
        </el-menu-item>
        <el-menu-item index="clusters" @click="goto('clusters')">
          <i class="el-icon-cloudy"></i>
          <span slot="title">kubernetes 集群</span>
        </el-menu-item>
        <el-submenu index="dns">
          <template slot="title">
            <i class="el-icon-notebook-2"></i>
            <span>域名解析</span>
          </template>
          <el-menu-item index="zones" @click="goto('zones')">域名</el-menu-item>
          <el-menu-item index="records" @click="goto('records')">记录</el-menu-item>
        </el-submenu>
        <el-submenu index="setting">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>设置</span>
          </template>
          <el-menu-item-group>
            <template slot="title">用户及权限</template>
            <el-menu-item index="users" @click="goto('users')">用户</el-menu-item>
            <el-menu-item index="roles" @click="goto('roles')">角色</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <template slot="title">配置</template>
            <el-menu-item index="mails" @click="goto('mails')">邮箱</el-menu-item>
            <el-menu-item index="ldaps" @click="goto('ldaps')">LDAP</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <el-row>
          <el-col :span="12" style="padding: 20px;">
            <!-- <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>
                <a href="/">活动管理</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item>活动列表</el-breadcrumb-item>
              <el-breadcrumb-item>活动详情</el-breadcrumb-item>
            </el-breadcrumb>-->
          </el-col>
          <el-col :span="12">
            <el-menu class="el-menu-demo" mode="horizontal">
              <el-submenu index="current" style="float: right">
                <template slot="title">{{ nick_name }}</template>
                <el-menu-item index="profile" @click="goto('profile')">个人信息</el-menu-item>
                <el-menu-item index="logout" @click="logout">退出</el-menu-item>
              </el-submenu>
            </el-menu>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <div style="margin: 10px 0"></div>
        <div :style="conheight">
          <router-view />
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      current: [],
      nick_name: "",
      user: {},
      conheight: {
        // background: "#fff",
        padding: "24px",
        "min-height": window.innerHeight - 170 + "px",
      },
    };
  },
  created() {
    this.current.push(this.$route.path.split("/", 2)[1]);
    this.nick_name = this.username();
  },
  methods: {
    logout() {
      this.config.clearInfo();
      this.$router.push("login");
    },
    username() {
      return this.config.getLoginInfo().data.nickName;
    },
    goto(where) {
      let will = "/" + where;
      if (will === this.$route.path) {
        this.$router.go(0);
        return
      }
      this.$router.push({ name: where });
    },
  },
};
</script>

<style>
.nick-name {
  font-weight: bold;
  font-size: 18px;
}

.menu-logo {
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-weight: 600;
  color: #6dacea;
}

.menu-title {
  color: #a6adb4;
  font-size: 30px;
  font-weight: bold;
  margin: 0 auto;
  text-align: center;
  display: flex;
}

html,
body,
#app,
.el-container {
  /*设置内部填充为0，几个布局元素之间没有间距*/
  padding: 0px;
  /*外部间距也是如此设置*/
  margin: 0px;
  /*统一设置高度为100%*/
  height: 100%;
}

.el-header {
  /* background-color: #b3c0d1; */
  color: #333;
  text-align: center;
  line-height: 60px;
  height: 60px;
}

.el-aside {
  /* text-align: center; */
  color: #fff;
  background-color: #545c64;
  /* text-color: #fff; */
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  /* line-height: 160px; */
  padding: 0;
}

body > .el-container {
  margin-bottom: 40px;
}
</style>